import * as actionTypes from './actionTypes';

export const initialiseCommonStore = (events, counter) => {
    return {
        type: actionTypes.COMMON_REDUX_STORE_INITIALISE,
        events: { ...events },
        counter: counter,
    };
};

export const updateCommonStoreFromEventsWsData = wsData => {
    return {
        type: actionTypes.COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS,
        wsData: wsData,
    };
};

export const clearCommonStore = () => {
    return {
        type: actionTypes.COMMON_REDUX_STORE_CLEAR,
    };
};

export const updateCommonStoreMarkets = (events) =>{
    return {
        type: actionTypes.COMMON_REDUX_STORE_UPDATE_FROM_BACKEND,
        events,
    };
};
